import React from 'react'
import * as styles from './index.module.css'
import { GatsbyImage } from 'gatsby-plugin-image'
import { GradientBorder } from '../commons'
import Button from '../Button/'

const OsGeneric = (props) => {
  let withImage = props.images && props.images.length > 0 ? true : false

  const splitSubtitleElements = props.subtitle.subtitle
    .split('\n\n')
    .map((paragraphText, idx) => {
      return (
        <p key={paragraphText.substring(0, 10)} key={idx}>
          {paragraphText}
        </p>
      )
    })

  return (
    <div className="wrapper">
      <div className={styles.container}>
        {((typeof window !== `undefined` && window.innerWidth <= 450) ||
          !withImage) && (
          <GradientBorder height="1px" style={{ marginBottom: '19px' }} />
        )}
        {!withImage && (
          <div>
            <div
              className={styles.description}
              style={{ width: '85%', margin: '0 auto' }}
            >
              {splitSubtitleElements}
            </div>
          </div>
        )}
        {withImage && (
          <div className={styles.flexContainer}>
            <div className={styles.section}>
              {typeof window !== `undefined` && window.innerWidth > 450 && (
                <GradientBorder height="1px" style={{ marginBottom: '19px' }} />
              )}
              <h2 className={styles.title}>{props.title}</h2>
              <div className={styles.description}>{splitSubtitleElements}</div>
            </div>
            <div className={styles.section}>
              <GatsbyImage
                image={props.images[0].gatsbyImageData}
                className={styles.image}
                alt={props.images[0]?.description}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default OsGeneric
